import { Navigate, RouteObject } from "react-router-dom";
import { Routes } from "../routes";
import { lazy } from "react";

const GetStarted = lazy(() => import('views/onboarding/getStarted'));
const UploadDocument = lazy(() => import('views/onboarding/getStarted/UploadDocument'));
const AboutBusiness = lazy(() => import('views/onboarding/getStarted/aboutBusiness'));
const BusinessInfo = lazy(() => import('views/onboarding/businessInfo'));
const Registration = lazy(() => import('views/onboarding/registration'));
const People = lazy(() => import('views/onboarding/people'));
const PeopleOwnerShipStructure = lazy(() => import('views/onboarding/people/PeopleOwnerShipStructure'));
const Account = lazy(() => import('views/onboarding/account'));
const Summary = lazy(() => import('views/onboarding/summary'));


// login , register, others
export const onboardingRoutes = () => {
    return [
      {
        path: Routes.getStarted,
        element: <GetStarted/>,
      },
      {
        path: Routes.getStartedUpload,
        element: <UploadDocument/>,
      },
      {
        path: Routes.getStartedAboutBusiness,
        element: <AboutBusiness/>,
      },
      {
        path: Routes.businessOnboardingInfoStep,
        element: <BusinessInfo/>,
      },

      {
        path: Routes.businessRegistrationStep,
        element: <Registration/>,
      },
      {
        path: Routes.businessOnboardingPeopleStep,
        element: <People/>,
      },
      {
        path: Routes.businessOnboardingPeopleOwnerShipStructure,
        element: <PeopleOwnerShipStructure/>,
      },
      {
        path: Routes.businessOnboardingAccount,
        element: <Account/>,
      },
      {
        path: Routes.businessOnboardingSummary,
        element: <Summary/>,
      },
      // TODO: determine next route
      {path: Routes.onboarding, element: <Navigate to={Routes.getStarted} replace/> },
      //  NOTE: you might want to check which sreen to show first instead of the first route
      {path: Routes.businessInfo, element: <Navigate to={Routes.businessOnboardingInfoProfile} replace /> },
      {path: Routes.businessRegistration, element: <Navigate to={Routes.businessRegistrationInfo} replace /> },
      {path: Routes.businessOnboardingPeople, element: <Navigate to={Routes.businessOnboardingPeopleProfile} replace /> }
    ] as RouteObject[];
  };